/** @graphql cc **/

import gql from 'graphql-tag';

export const TitleContentPropertyQuery = gql`
	query TitleContentPropertyQuery($contentId: ID, $status: [String]) {
		content(id: $contentId, status: $status) {
			nodes {
				id
				pageTitlePublished: properties(key: "page-title-property-published") {
					nodes {
						id
						key
						value
						version {
							number
						}
					}
				}
				pageTitleDraft: properties(key: "page-title-property-draft") {
					nodes {
						id
						key
						value
						version {
							number
						}
					}
				}
				metadata {
					frontend {
						coverPictureWidth
					}
				}
			}
		}
	}
`;

export const HomepageIdQuery = gql`
	query HomepageIdQuery($spaceKey: String!) {
		space(key: $spaceKey) {
			id
			homepage {
				id
			}
		}
	}
`;
